import * as actions from "../action.constants";

const initialState = {
  etheretConfigurationsNew: [],
  portForwardingConfigurations: [],
  modbusTcpIp: false,
  cellularModem: false,
  aquaticGroupProfiles: {},
};

const storeEthernetConfigs = (state, action) => ({
  ...state,
  etheretConfigurationsNew: action.payload.map((each) => ({
    ...each,
    configType: "ethernet",
  })),
});

const savePortForwarding = (state, action) => ({
  ...state,
  portForwardingConfigurations: action.payload.map((each) => ({
    ...each,
    configType: "portForward",
  })),
});

const storeModbusTcpIp = (state, action) => ({
  ...state,
  modbusTcpIp: action.payload,
});

const storeCellularModem = (state, action) => ({
  ...state,
  cellularModem: action.payload,
});

const storeAquaticGroupProfiles = (state, action) => ({
  ...state,
  aquaticGroupProfiles: action.payload || {},
});

const handlers = {
  [actions.STORE_ETHERNET_CONFIG]: storeEthernetConfigs,
  [actions.STORE_PORT_FORWARDING_CONFIGURATIONS]: savePortForwarding,
  [actions.STORE_MODBUS_TCP_IP]: storeModbusTcpIp,
  [actions.STORE_CELLULAR_MODEM]: storeCellularModem,
  [actions.STORE_AQUATIC_GROUP_PROFILES]: storeAquaticGroupProfiles,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
